<template>
	<div class="logout">
		<Loading />
	</div>
</template>

<script>
// @ is an alias to /src
import Loading from '@/components/shared/Loading/index';

export default {
	methods: {
		handleLoginEvent() {
			this.$router.push('/');
		}
	},
	components: {
		Loading
	},
	created() {
		this.$auth.logout();
	}
};
</script>
